import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
	Grid,
	Typography,
	TextField,
	Button,
	IconButton
} from '@material-ui/core';
import axios from 'axios'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import CloseIcon from '@material-ui/icons/Close';
import Config from '../../commons/config/Config.js'
import { castValoresDinamicos } from '../atributoDinamico/helpers.js'
import * as Constants from '../atributoDinamico/constants.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const configAxios = {
	headers: {
		'Authorization-Token': localStorage.getItem("token")
	}
};

const ModalAccion = ({ reporte, onClose, onConfirm, onDesestimar, accion, loading, mostrarBase }) => {
	const intl = useIntl()
	const [comentario, setComentario] = useState('');
	const [valoresDinamicos, setValoresDinamicos] = useState([]);

	useEffect(() => {
		if(accion) {
			let valoresDinamicos = castValoresDinamicos(reporte.safe_feedback_tipo_formulario.atributos_dinamicos, reporte.valores_dinamicos, false)
			setValoresDinamicos(valoresDinamicos);
			setComentario('');
		}
	}, [accion]);

	const openImage = (adjunto_id) => {
		let config = Object.assign({}, configAxios, { responseType: 'blob' });
		axios.get(Config.get('apiUrlBase') + '/adjuntos/files/' + adjunto_id, config).then(response => {
			if (response.status === 200) {
				let fileUrl = URL.createObjectURL(response.data);
				window.open(fileUrl)
			}
		}).catch((e) => { console.log(e) });
	}
		
	if (!reporte) return null;

	return (
		<>
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>
							{accion === 'confirmar' ? (
								<CheckCircleIcon style={{ color: '#28a745' }} />
							) : (
								<CancelIcon style={{ color: '#dc3545' }} />
							)}
						</Grid>
						<Grid item>
							<Typography variant="h6">
								{accion === 'confirmar' ? (
									<FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Confirmar_Queja" defaultMessage="Confirmar Queja" />
								) : (
									<FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Desestimar_Queja" defaultMessage="Desestimar Queja" />
								)}
							</Typography>
						</Grid>
					</Grid>
				</Grid>

				<Grid item>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
			</Grid>

			<Grid container spacing={2} style={{ marginTop: 16 }}>
				<Grid item xs={6}>
					<Typography><FormattedMessage id="SafeFeedbackFormularioModalAccion.render.ID" defaultMessage="ID" /></Typography>
					<Typography><b>#{reporte.id}</b></Typography>
					
					<br/>
					<Typography><FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Fecha_y_Hora_de_Creacion" defaultMessage="Fecha y hora de creación" /></Typography>
					<Typography><b>{LocaleFormat.formatDateTime(reporte.created_at)}</b></Typography>
				</Grid>

				<Grid item xs={6}>
					<Typography><FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Vehículo" defaultMessage="Vehículo" /></Typography>
					<Typography><b>{reporte.dominio}</b></Typography>

					<br/>
					<Typography><FormattedMessage id="SafeFeedbackFormularioModalAccion.render.tipo_formulario" defaultMessage="Tipo de formulario" /></Typography>
					<Typography><b>{reporte.safe_feedback_tipo_formulario ? reporte.safe_feedback_tipo_formulario.nombre : ''}</b></Typography>
				</Grid>
				{mostrarBase && (
					<Grid item xs={6}>
						<Typography><FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Base" defaultMessage="Base" /></Typography>
						<Typography><b>{reporte.base ? reporte.base.descripcion : ''}</b></Typography>
					</Grid>
				)}
			</Grid>
			<br/>
			{valoresDinamicos.map((valorDinamico, index) => (
				valorDinamico.activo ?
					<div className="row" style={{ minWidth: "30vw" }} key={index}>
						<span className="col-5">
							{valorDinamico.nombre}:
						</span>
						
						<div className="col-7">
							{Constants.INSTANCIAS_DICT[valorDinamico.tipoValor].conAdjunto ?
								<>
									<span>
										{valorDinamico.value && typeof(valorDinamico.value) === 'number' && 
											<i
											onClick={event => openImage(valorDinamico.value)}
											className="cursor-pointer pr-1 fa fa-2x fa-paperclip">
											</i>
										}
										{valorDinamico.value && typeof(valorDinamico.value) !== 'number' && valorDinamico.value.map((e, i) => 
											<i
											key={i}
											onClick={event => openImage(e)}
											className="cursor-pointer pr-1 fa fa-2x fa-paperclip">
											</i>
										)}
										{(!valorDinamico.value || (Array.isArray(valorDinamico.value) && valorDinamico.value.length === 0)) && intl.formatMessage({ id: 'safeFeedbackFormularioModalView.information_no_posee_adjunto', defaultMessage: 'No posee adjunto' })}
									</span>
								</>
							: 
								<span>
									{valorDinamico.value}
								</span>
							}
						</div>
					</div>
				: ''
			))}
			<br/>
			<Typography
				style={{ marginTop: 16 }}
			>
				<FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Comentarios" defaultMessage="Comentarios" />{accion === 'desestimar' ? '*' : ''}
			</Typography>
			<TextField
				placeholder={accion === 'confirmar' ?
					intl.formatMessage({id: "SafeFeedbackFormularioModalAccion.render.Comentarios_adicionales_opcional", defaultMessage: "Comentarios adicionales (opcional)..."}) :
					intl.formatMessage({id: "SafeFeedbackFormularioModalAccion.render.Explique_razon_desestimacion", defaultMessage: "Explique la razón de la desestimación..."})
				}
				fullWidth
				multiline
				minRows={3}
				variant="outlined"
				value={comentario}
				inputProps={{ maxLength: 250 }}
				onChange={(e) => setComentario(e.target.value)}
			/>

			<Grid
				container
				justifyContent="flex-end"
				spacing={1}
				style={{ marginTop: 24 }}
			>
				<Grid item>
					<Button onClick={onClose}>
						<FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Cancelar" defaultMessage="Cancelar" />
					</Button>
				</Grid>
				<Grid item>
					{
						accion === 'confirmar' ?
							<Button
								className="btn btn-primary"
								onClick={() => onConfirm(comentario)}
								disabled={loading}
							>
								<FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Confirmar" defaultMessage="Confirmar" />
							</Button>
						:
							<Button
								className="btn btn-danger"
								onClick={() => onDesestimar(comentario)}
								disabled={comentario === '' || loading}
							>
								<FormattedMessage id="SafeFeedbackFormularioModalAccion.render.Desestimar" defaultMessage="Desestimar" />
							</Button>
					}
				</Grid>
			</Grid>
		</>
	);
};

export default ModalAccion;
